<template>
  <div>
    <radio-group
      :label="question.label"
      :helptext="question.helpText"
      :collapsibleContent="question.content"
      :options="question.options"
      :tooltip="question.tooltip"
      :isActiveTooltip="isActiveTooltip"
      @toggleTooltip="toggleTooltip"
      v-on:change="emitInput"
    />
    <bordered-content v-if="cmsText">
      <div v-html="cmsText"></div>
    </bordered-content>
    <div v-if="liveChat || externalLink">
      <button
        type="button"
        class="c-button c-button--brand"
        v-if="liveChat"
      >
        Live Chat
      </button>
      <a
        class="c-button c-button--brand"
        v-bind:href="externalLinkUrl"
        v-if="externalLink"
      >
        {{ externalLinkText }}
      </a>
    </div>
  </div>
</template>

<script>
  import RadioGroup from "../../forms/radio-group/RadioGroup.vue";
  import BorderedContent from "./BorderedContent.vue";
  export default {
    components: {
      RadioGroup,
      BorderedContent,
    },
    props: {
      index: {
        required: true,
        type: Number,
      },
      question: {
        required: true,
        type: Object,
      },
      activeTooltipId: {
        type: String,
      },
    },
    data() {
      return {
        cmsText: null,
        externalLink: null,
        externalLinkText: null,
        externalLinkUrl: null,
        liveChat: null,
      };
    },
    destroyed() {
      this.question.answer = "";
      this.question.answerLabel = "";
    },
    computed: {
      isActiveTooltip() {
        return this.activeTooltipId === this.question.label
      }
    },
    methods: {
      toggleTooltip(value) {
        this.$emit('activeTooltip', value ? this.question.label : '')
      },
      emitInput(optionIndex, option) {
        this.cmsText = this.question.options[optionIndex].text;
        this.externalLink =
          this.question.options[optionIndex].linkText &&
          this.question.options[optionIndex].linkUrl;
        this.externalLinkText = this.question.options[optionIndex].linkText;
        this.externalLinkUrl = this.question.options[optionIndex].linkUrl;
        this.liveChat = this.question.options[optionIndex].chat;

        this.$emit(
          "input",
          option.value,
          this.index,
          this.question.id,
          option.nextId,
          option.final,
          option.upload
        );
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/RadioGroupOptions.vue